import { render } from "./zcfzTable3.vue?vue&type=template&id=9a40f9fa&scoped=true"
import script from "./zcfzTable3.vue?vue&type=script&lang=js"
export * from "./zcfzTable3.vue?vue&type=script&lang=js"

import "./zcfzTable3.vue?vue&type=style&index=0&id=9a40f9fa&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a40f9fa"]])

export default __exports__